/**
 * Sync directory List/Map with `?view=map` (browse discovery key).
 * Hash is unused for map context — do not invent a hash router.
 */
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  parseDirectoryViewMode,
  withDirectoryViewModeInSearch,
  type DirectoryViewMode,
} from '../../shared/session/directoryViewMode.js';

export type { DirectoryViewMode };

export function useDirectoryViewModeSearch(): {
  readonly viewMode: DirectoryViewMode;
  readonly setViewMode: (next: DirectoryViewMode) => void;
} {
  const location = useLocation();
  const navigate = useNavigate();
  const viewMode = parseDirectoryViewMode(location.search);

  const setViewMode = useCallback(
    (next: DirectoryViewMode): void => {
      const nextSearch = withDirectoryViewModeInSearch(location.search, next);
      if (nextSearch === location.search || (nextSearch === '' && location.search === '')) {
        return;
      }
      navigate(
        { pathname: location.pathname, search: nextSearch, hash: location.hash },
        { replace: true },
      );
    },
    [location.hash, location.pathname, location.search, navigate],
  );

  return { viewMode, setViewMode };
}
